import { render, staticRenderFns } from "./reasonDialog.vue?vue&type=template&id=4219a5f4&scoped=true&"
import script from "./reasonDialog.vue?vue&type=script&lang=js&"
export * from "./reasonDialog.vue?vue&type=script&lang=js&"
import style0 from "./reasonDialog.vue?vue&type=style&index=0&id=4219a5f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4219a5f4",
  null
  
)

export default component.exports